module.exports = __webpack_public_path__ + "static/media/line-size-1.f4dd3cc3.svg";